<template>
  <v-flex>
    <v-flex v-if="loadAction.failed"
            class="admin-only-text">
      hey
      <div class="admin-only-text__wrapper" >
        <div class="admin-only-text__title">{{chapterWaiverConstants.ADMIN_ONLY_TITLE}}</div>
        <div class="admin-only-text__details">{{chapterWaiverConstants.ADMIN_ONLY_TEXT}}</div>
      </div>
    </v-flex>
    <v-flex v-else-if="!loadAction.failed && checkedWaiverVisibility">
      <ChapterWaiverBanner></ChapterWaiverBanner>
      <v-container>
        <v-flex
            md12
            mx-auto
            my-5
            class="waiver-block">
          <v-card class="panelBlock">
            <v-layout
                row
                wrap
                class="prospective-member-header">
              <v-flex
                  xs12
                  sm12
                  md4
                  lg3>
                <v-flex tag="h2">{{chapterWaiverConstants.PROSPECTIVE_MEMBER_WAIVERS}}</v-flex>
              </v-flex>
              <v-flex
                  xs12
                  sm6
                  md4
                  lg3
                  class="prospective-member-header__sort__block"
                  v-if="isWaiverList">
                <v-flex class="prospective-member-header__sort">
                  <span>Sort By</span>
                  <v-select
                      class="sort_select"
                      item-text="text"
                      item-value="value"
                      :items="sortItems"
                      v-model="sortBy"
                      solo
                      flat
                      hide-details
                      v-on:change="sortWaivers"
                      data-qe-id="chapter_admin_sort_waivers">
                  </v-select>
                  <v-flex v-if="isSorted" class="sort_select__clear">
                    <span data-qe-id="clear_filter_sort" @click="clearSortFilter">{{chapterWaiverConstants.CLEAR_FILTER}}</span>
                  </v-flex>
                </v-flex>
              </v-flex>
              <v-flex
                  xs12
                  sm6
                  md4
                  lg3
                  class="prospective-member-header__sort__block"
                  v-if="isWaiverList">
                <v-flex class="prospective-member-header__sort">
                  <span>Filter</span>
                  <v-select
                      class="sort_select"
                      item-text="text"
                      item-value="value"
                      :items="filterItems"
                      v-model="filterBy"
                      solo
                      flat
                      hide-details
                      v-on:change="filterWaivers"
                      data-qe-id="chapter_admin_filter_waivers">
                  </v-select>
                  <v-flex v-if="isFiltered" class="sort_select__clear">
                    <span data-qe-id="clear_filter_filters" @click="clearFilters">{{chapterWaiverConstants.CLEAR_FILTER}}</span>
                  </v-flex>
                </v-flex>
              </v-flex>
              <v-flex
                  v-if="!isWaiverList"
                  data-qe-id="PrpAdmin_Waivers_showAll_link"
                  class="view-all-waivers__all-waivers"><span class="ypo_blue_color" @click="ShowAllWaiver()">{{chapterWaiverConstants.VIEW_ALL_WAIVERS}}</span></v-flex>
              <v-flex
                  xs12
                  sm6
                  md4
                  lg3
                  class="prospective-member-header__prospect"
                  v-if="isWaiverList">
                <v-text-field
                    prepend-inner-icon="search"
                    label="Search for a prospect"
                    single-line
                    solo
                    data-qe-id="prpadmin_waiverSearch"
                    clearable
                    v-model="waiverSearchText"
                    @keyup="searchWaiverDialog"
                    @click:clear="clearSearchText()"
                    hide-details
                    flat
                    class="search_bar">
                </v-text-field>
                <v-flex class="result inner-scrollbar">
                  <v-flex v-if="waiverSearchInProgress && hideSearchResults" class="result__spinner">
                    <status-overlay :action="{pending: waiverSearchInProgress}"></status-overlay>
                  </v-flex>
                  <v-flex v-if="!waiverSearchInProgress && hideSearchResults">
                    <v-list
                        two-line
                        v-for="(lead, i) in searchWaiverResult"
                        :key="i">
                      <v-list-tile @click="selectWaiver(lead.id)">
                        <v-list-tile-avatar>
                          <img :src="lead.profileImageUrl" :onerror="imageErrorFallback(lead)">
                        </v-list-tile-avatar>
                        <v-list-tile-content>
                          <v-list-tile-title>{{lead.firstName}} {{lead.lastName}}</v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                    </v-list>
                  </v-flex>
                  <v-list
                      class="result__see-all"
                      one-line
                      v-if="chunkedSearchResults && !waiverSearchInProgress && hideSearchResults">
                    <v-list-tile data-qe-id="prp_admin_search_seemore" @click="seeMore()">
                      <v-list-tile-content>
                        <v-list-tile-title>{{chapterWaiverConstants.SEEALL}}</v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </v-list>
                </v-flex>
              </v-flex>
            </v-layout>

            <div
                v-infinite-scroll="getListOfWaiversAdminView"
                :infinite-scroll-distance="2000">
              <v-flex v-if="!isSearchResult">
                <v-flex
                    class="prospective-member"
                    v-for="(prospectData, i) in listOfWaivers"
                    :key="i">
                  <WaiverTileAdmin :waiverDetails="prospectData" :i="i" />
                </v-flex>
                <v-flex
                    class="prospective-member__loading"
                    v-if="loadAction.pending"
                    justify-center
                    text-xs-center>
                  <v-progress-circular indeterminate color="grey"></v-progress-circular>
                </v-flex>
                <v-flex
                    class="prospective-member__loading"
                    v-else-if="loadAction.failed"
                    justify-center
                    text-xs-center>
                  {{chapterWaiverConstants.INSUFFICIENT_PERMISSIONS}}
                </v-flex>
                <v-flex
                    class="prospective-member__loading"
                    v-else-if="!loadAction.pending && listOfWaivers && !(listOfWaivers.length > 0)"
                    justify-center
                    text-xs-center>
                  {{chapterWaiverConstants.WAIVER_LIST_EMPTY}}
                </v-flex>
              </v-flex>
            </div>
            <div v-if="isSearchResult">
              <v-flex
                  class="prospective-member__loading"
                  v-if="isSelectedLoad"
                  justify-center
                  text-xs-center>
                <v-progress-circular indeterminate color="grey"></v-progress-circular>
              </v-flex>
              <v-flex class="prospective-member" v-if="!isSelectedLoad">
                <WaiverTileAdmin :waiverDetails="waiverDetails" :i="1" />
              </v-flex>
            </div>
          </v-card>
        </v-flex>
      </v-container>
    </v-flex>
  </v-flex>
</template>

<script>
    import ChapterWaiverBanner from "./ChapterWaiverBanner";
    import { chapterWaiverConstants, waiverStates, waiverValidationConstants, sortItems, filterItems } from "./ChapterWaiver.constants";
    import { mapGetters, mapMutations, mapActions, mapState } from "vuex";
    import { storeGetters } from "../../store/storeGetters.constant";
    import { storeAction } from "../../store/storeActions.constant";
    import { storeMutation } from "../../store/storeMutations.constant";
    import { getFormattedDate } from "../../common/utils/dateTime";
    import StatusOverlay from '@/components/StatusOverlay/StatusOverlay';
    import WaiverTileAdmin from "./WaiverTileAdmin";
    import { headerConstant } from "../Header/header.constant";

    export default {
        name: "PeerReviewPanelAdmin",
        components: {
            ChapterWaiverBanner,
            StatusOverlay,
            WaiverTileAdmin,
        },
        created() {
            if (this.$route.query.leadId) {
                this.leadId = this.$route.query.leadId;
            }
            this.resetChapterWaiverList();
            this.determineWaiversView();
            this.getWaiverQuestions();
            this.getCompanyTypes();
            this.getWaiverTypes();
            this.getTitleTypes();
            this.getCorporationTypes();
        },
        data: () => {
            return {
                chapterWaiverConstants,
                getListWaiverInProgress: false,
                waiverStates,
                getFormattedDate,
                waiverValidationConstants,
                waiverSearchText: '',
                waiverSearchInProgress: false,
                hideSearchResults: false,
                isSearchResult: false,
                isSelectedLoad: false,
                sortBy: 0,
                isSorted: false,
                sortItems,
                filterItems,
                filterBy: 0,
                isFiltered: false,
                leadId: headerConstant.EMPTY_GUID,
                headerConstant,
                checkedWaiverVisibility: false,
            };
        },
        methods: {
            ...mapActions({
                getListOfWaivers: `chapterWaiver/${storeAction.getListOfWaivers}`,
                getWaiverDetails: `chapterWaiver/${storeAction.getWaiverDetails}`,
                getWaiverQuestions: `chapterWaiver/${storeAction.getWaiverQuestions}`,
                getCompanyTypes: `chapterWaiver/${storeAction.getCompanyTypes}`,
                searchWaiverRequests: `chapterWaiver/${storeAction.searchWaiverRequests}`,
                getWaiverTypes: `chapterWaiver/${storeAction.getWaiverTypes}`,
                getTitleTypes: `chapterWaiver/${storeAction.getTitleTypes}`,
                getCorporationTypes: `chapterWaiver/${storeAction.getCorporationTypes}`,
            }),
            ...mapMutations({
                resetChapterWaiverList: `chapterWaiver/${storeMutation.resetChapterWaiverList}`,
                pushSearchResults: `chapterWaiver/${storeMutation.pushSearchResults}`,
                removeSearchResults: `chapterWaiver/${storeMutation.removeSearchResults}`,
                setVisibleProspect: `chapterWaiver/${storeMutation.setVisibleProspect}`,
                setSearchResults: `chapterWaiver/${storeMutation.setSearchResults}`,
            }),
            ShowAllWaiver() {
                this.resetChapterWaiverList();
                this.$router.push({
                    path: '/peerReviewPanelAdmin',
                });
            },
            determineWaiversView() {
              this.getListOfWaiversAdminView();
            },
            getListOfWaiversAdminView() {
                if (!this.disableWaiverListInfiniteScroll && !this.getListWaiverInProgress && !this.searchResults) {
                    this.getListWaiverInProgress = true;
                    const viewType = this.chapterWaiverConstants.PRPADMIN;
                    const sortType = this.sortBy;
                    const filterType = this.filterBy;
                    const leadId = this.leadId ? this.leadId : this.headerConstant.EMPTY_GUID;
                    const req = {
                        viewType,
                        sortType,
                        filterType,
                        leadId,
                    };
                    this.getListOfWaivers(req)
                        .finally(() => {
                            this.getListWaiverInProgress = false;
                            this.checkedWaiverVisibility = true;
                        });
                }
            },
            imageErrorFallback(element) {
                element.profileImageUrl = element.fallbackProfileImageUrl;
                return `this.src='${element.fallbackProfileImageUrl || ''}';this.onerror=null;`;
            },
            searchWaiverDialog() {
                this.setVisibleProspect(null);
                if (this.waiverSearchText === '' || (this.waiverSearchText && this.waiverSearchText.length <= 2)) {
                    this.hideSearchResults = false;
                    this.isSearchResult = false;
                    return false;
                }
                this.hideSearchResults = true;
                this.waiverSearchInProgress = true;
                const req = {
                    viewType: this.chapterWaiverConstants.PRPADMIN,
                    communityId: '00000000-0000-0000-0000-000000000000',
                    searchToken: this.waiverSearchText,
                };
                this.searchWaiverRequests(req).then(() => {
                    this.waiverSearchInProgress = false;
                });
            },
            clearSearchText() {
                this.setSearchResults(null);
                this.hideSearchResults = false;
                this.isSearchResult = false;
                this.removeSearchResults();
                this.setVisibleProspect(null);
            },
            selectWaiver(id) {
                this.getListWaiverInProgress = true;
                this.isSelectedLoad = true;
                const req = {
                    viewType: this.chapterWaiverConstants.PRPADMIN,
                    leadId: id,
                };
                this.getWaiverDetails(req)
                    .then(() => {
                        this.isSelectedLoad = false;
                        this.getListWaiverInProgress = false;
                        this.hideSearchResults = false;
                        this.isSearchResult = true;
                    });
            },
            sortWaivers() {
                this.resetChapterWaiverList();
                this.getListOfWaiversAdminView();
                this.isSorted = this.sortBy !== 0;
            },
            clearSortFilter() {
                this.sortBy = 0;
                this.sortWaivers();
                this.isSorted = false;
            },
            seeMore() {
                this.pushSearchResults();
            },
            filterWaivers() {
                this.resetChapterWaiverList();
                this.getListOfWaiversAdminView();
                this.isFiltered = this.filterBy !== 0;
            },
            clearFilters() {
                this.filterBy = 0;
                this.filterWaivers();
                this.isFiltered = false;
            },
        },
        computed: {
            ...mapState("actionState", ["actions"]),
            ...mapGetters({
                listOfWaivers: `chapterWaiver/${storeGetters.listOfWaivers}`,
                disableWaiverListInfiniteScroll: `chapterWaiver/${storeGetters.disableWaiverListInfiniteScroll}`,
                waiverDetails: `chapterWaiver/${storeGetters.waiverDetails}`,
                searchWaiverResult: `chapterWaiver/${storeGetters.searchResults}`,
                chunkedSearchResults: `chapterWaiver/${storeGetters.chunkedSearchResults}`,
            }),
            ...mapMutations({
                setWaiverStatusLocally: `chapterWaiver/${storeMutation.setWaiverStatusLocally}`,
            }),
            loadAction() {
                return this.actions[storeAction.getListOfWaivers];
            },
            isWaiverList() {
                return this.leadId === this.headerConstant.EMPTY_GUID;
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import "../../common/styles/_colors.scss";
    @import "../../common/styles/responsive.scss";

    .prospective-member-header {
        &__sort__block {
            padding-right: 24px;
        }

        @include breakpoint(md) {
            &__sort__block {
                padding: 0 16px;
            }

            &__prospect {
                padding-left: 16px;
                margin-top: 10px;
            }
        }

        @include breakpoint(xs) {
            &__sort__block {
                padding: 6px 0;
            }

            &__prospect {
                padding-left: 0;
            }
        }
    }

    .admin-only-text {
      display: flex;
      justify-content: center;
      text-align: center;
      &__wrapper {
        margin-top: 10%;
        max-width: 350px;
      }
      &__title {
        color: $ypo-primary-blue;
        font-size: 18px;
      }
    }
</style><style lang="scss">
    @import "../../common/styles/_colors.scss";
    @import "../../common/styles/responsive.scss";

    .view-all-waivers {
        &__all-waivers {
            padding: 14px 10px 0 10px;
            position: absolute;
            right: 10px;
            top: 10px;

            span {
                text-decoration: underline;
                font-weight: 600;
                cursor: pointer;
            }

            @include breakpoint(xs) {
                position: relative;
                text-align: center;
            }

        }
    }

    .sort_select {
        .v-text-field__details {
            display: none;
        }

        .v-input__control {
            min-height: inherit !important;
        }

        .v-input__slot {
            box-shadow: none !important;
            border: 1px solid $ypo-medium-gray;
            border-radius: 3px;
        }

        &__clear {
            span {
                cursor: pointer;
                position: relative;
                left: 0;
                top: -2px;
                color: $ypo-cta;
                font-style: italic;
                font-size: 12px;
            }
        }
    }
</style>
